<template>
  <div class="bodyed">
    <span class="box">
      <!-- 头部 -->
      <div class="box_title">
        <div class="left">生产制造看板</div>
        <div class="right">
          <span>{{nianyue}}</span>
          <span>{{xinqi}}</span>
          <span>{{timed}}</span>
          <img style="width: 0.4rem;margin-right: .1rem;margin-left: .4rem;" src="../../assets/kanban/tianqi.png"
            alt="">
          <span>珠海</span>
          <span>{{tianqi}}</span>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="viewport">
        <div class="column">
          <!--概览-->

          <!--月出货量-->
          <div class="li">
            <div class="li_tit">
              <div class="name">月出货量</div>
              <div class="txt">Monthly delivery volume</div>
            </div>
            <div class="users panel">
              <div class="inner">

                <div class="chart">
                  <vchart style="height: 100%;" ref='vchart1'></vchart>
                </div>
              </div>
            </div>
          </div>

          <!-- 在产数量 -->
          <div class="li">
            <div class="li_tit">
              <div class="name">在产数量</div>
              <div class="txt">Quantity in production</div>
            </div>
            <div class="users panel">
              <div class="inner">
                <div class="xianshi">
                  <div class="p">配电箱<div class="txt">{{producingNum.pdx}}</div>台</div>
                  <div class="p">高压柜<div class="txt">{{producingNum.gyg}}</div>台</div>
                  <div class="p">低压柜<div class="txt">{{producingNum.dyg}}</div>台</div>
                </div>
                <div class="chart">
                  <vchart style="height: 100%;" ref='vchart2'></vchart>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column">
          <!-- 中间图片 -->
          <div class="map">
            <div class="m_box">
              <div class="li">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计合同数</div>
                <div class="x"><span class="txt">{{cainian.leijihetong}}</span><span
                    style=" line-height: .24rem;  ">份</span></div>
              </div>
              <div class="li">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计合同额</div>
                <div class="x"><span class="txt">{{cainian.leijijine}}</span><span
                    style=" line-height: .24rem;  ">亿元</span></div>
              </div>
              <div class="li">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计产品数</div>
                <div class="x"><span class="txt">{{cainian.leijichanping}}</span><span
                    style=" line-height: .24rem;  ">项</span></div>
              </div>
            </div>
            <img src="../../assets/kanban/m2.png" alt="" style="width: 100%;position: absolute;top: -.53rem;">
            <img style="width: 100%;margin-top:0.27rem;height: 100%; display: block;" src="../../assets/kanban/m1.png"
              alt="">
          </div>

        </div>
        <div class="column">
          <!--用能概况-->
          <div class="li">
            <div class="li_tit">
              <div class="name">用能概况</div>
              <div class="txt">Can use situation</div>
            </div>
            <div class="users panel">
              <div class="inner">
                <div class="situation">
                  <div class="p">
                    <div class="top">
                      <div class="l">今日用电</div>
                      <div class="m">
                        <div class="txt">{{yongneng.dayValue}}</div>kwh
                      </div>

                      <div class="r">
                        <div class="n" v-if="dayRateShow">{{yongneng.dayRate}}</div>
                        <div class="n" v-if="dayUp">▲</div>
                        <div class="n Reverse" v-if="dayDown">▲</div>
                        <div class="n" v-if="dayTie">—</div>
                      </div>
                      <!--                      <div class="r" v-if="dayUp">-->
                      <!--                        <div class="n">{{dayRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r Reverse" v-if="dayDown">-->
                      <!--                        <div class="n">{{dayRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r" v-if="dayTie">-->
                      <!--&lt;!&ndash;                        <div class="n">{{yongneng.dayRate}}%</div>&ndash;&gt;-->
                      <!--                        <div class="r none">-->
                      <!--                        <div class="n">—</div>-->
                      <!--                      </div>-->
                      <!--                      </div>-->

                    </div>
                    <div class="bottom">昨日同期用电：{{yongneng.lastDayValue}}kwh</div>
                  </div>
                  <div class="p">
                    <div class="top">
                      <div class="l">当月用电</div>
                      <div class="m">
                        <div class="txt">{{yongneng.monthValue}}</div>kwh
                      </div>

                      <div class="r">
                        <div class="n" v-if="monthRateShow">{{yongneng.monthRate}}</div>
                        <div class="n" v-if="monthUp">▲</div>
                        <div class="n Reverse" v-if="monthDown">▲</div>
                        <div class="n" v-if="monthTie">—</div>
                      </div>
                      <!--                      <div class="r" v-if="monthUp">-->
                      <!--                        <div class="n">{{monthRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r Reverse" v-if="monthDown">-->
                      <!--                        <div class="n">{{monthRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r" v-if="monthTie">-->
                      <!--&lt;!&ndash;                        <div class="n">{{yongneng.monthRate}}%</div>&ndash;&gt;-->
                      <!--                        <div class="r none">-->
                      <!--                        <div class="n">—</div>-->
                      <!--                      </div>-->
                      <!--                      </div>-->

                    </div>
                    <div class="bottom">上月同期用电：{{yongneng.lastMonthValue}}kwh</div>
                  </div>
                  <div class="p">
                    <div class="top">
                      <div class="l">当年用电</div>
                      <div class="m">
                        <div class="txt">{{yongneng.yearValue}}</div>kwh
                      </div>

                      <div class="r">
                        <div class="n" v-if="yearRateShow">{{yongneng.yearRate}}</div>
                        <div class="n" v-if="yearUp">▲</div>
                        <div class="n Reverse" v-if="yearDown">▲</div>
                        <div class="n" v-if="yearTie">—</div>
                      </div>
                      <!--                      <div class="r" v-if="yearUp">-->
                      <!--                        <div class="n">{{yearRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r Reverse" v-if="yearDown">-->
                      <!--                        <div class="n">{{yearRate}}%</div>-->
                      <!--                        <div class="n">▲</div>-->
                      <!--                      </div>-->
                      <!--                      <div class="r" v-if="yearTie">-->
                      <!--&lt;!&ndash;                        <div class="n">{{yongneng.yearRate}}%</div>&ndash;&gt;-->
                      <!--                        <div class="r none">-->
                      <!--                        <div class="n">—</div>-->
                      <!--                      </div>-->
                      <!--                      </div>-->

                    </div>
                    <div class="bottom">上年同期用电：{{yongneng.lastYearValue}}kwh</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!--分项能耗-->
          <div class="li">
            <div class="li_tit">
              <div class="name">分项能耗</div>
              <div class="txt">Itemized energy consumption</div>
            </div>
            <div class="users panel">
              <div class="inner">
                <div class="Itemized">
                  <div class="p" v-for="(e,index) in fenxiang" :key="index">
                    <div class="name">{{e.name}}</div>
                    <div class="jindu">
                      <div class="n" :style="{width:e.dataRate + '%'}"></div>
                    </div>
                    <div class="text">{{e.dataRate}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三行-->
      <span class="bottom_box">
        <!-- 车间人数 -->
        <div class="li" style="width: 4.74rem;">
          <div class="li_tit">
            <div class="name">车间人数</div>
            <div class="txt">The number of workshop</div>
          </div>
          <div class="users panel">
            <div class="inner monitor">
              <h3>车间总人数 <div class="txt">{{workShopNum.total}}</div>人</h3>
              <div class="content" style="display: block;">
                <div class="marquee-view">
                  <div class="marquee">
                    <!--                 <div>-->
                    <!--                  <div>-->
                    <div class="row">
                      <span class="col">高压柜车间</span>
                      <span class="col">{{workShopNum.gyg}}</span>
                    </div>
                    <div class="row">
                      <span class="col">低压柜车间</span>
                      <span class="col">{{workShopNum.dyg}}</span>
                    </div>
                    <div class="row">
                      <span class="col">钣金车间</span>
                      <span class="col">{{workShopNum.bj}}</span>
                    </div>
                    <div class="row">
                      <span class="col">母线槽车间</span>
                      <span class="col">{{workShopNum.mxc}}</span>
                    </div>
                    <div class="row">
                      <span class="col">配电箱车间</span>
                      <span class="col">{{workShopNum.pdx}}</span>
                    </div>
                    <div class="row">
                      <span class="col">高压柜车间</span>
                      <span class="col">{{workShopNum.gyg}}</span>
                    </div>
                    <div class="row">
                      <span class="col">低压柜车间</span>
                      <span class="col">{{workShopNum.dyg}}</span>
                    </div>
                    <div class="row">
                      <span class="col">钣金车间</span>
                      <span class="col">{{workShopNum.bj}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- 负荷曲线 -->
        <div class="li" style="width: 8.38rem;">
          <div class="li_tit">
            <div class="name">负荷曲线</div>
            <div class="txt">Load curve</div>
          </div>
          <div class="users panel">
            <div class="inner inner2">

              <div class="chart">
                <vchart style="height: 100%;" ref='curve1'></vchart>
              </div>
            </div>
          </div>
        </div>
        <!-- 产值能耗比 -->
        <div class="li" style="width: 4.74rem;">
          <div class="li_tit">
            <div class="name">产值能耗比</div>
            <div class="txt">Output energy consumption ratio</div>
          </div>
          <div class="users panel">
            <div class="inner">
              <div class="chart">
                <vchart style="height: 100%;" ref='consumption1'></vchart>
              </div>

            </div>
          </div>
        </div>
      </span>
      <!-- 第四行 -->
      <span class="bottom_box">
        <!-- 未交货数 -->
        <div class="li" style="flex: 1;margin-right: 25px;">
          <div class="li_tit">
            <div class="name">未交货数</div>
            <div class="txt">Unfilled number</div>
          </div>
          <div class="users panel">
            <div class="inner inner2">
              <div class="chart">
                <vchart style="height: 100%;" ref='Unfilled1'></vchart>
              </div>
            </div>
          </div>
        </div>
        <!-- 同期对比 -->
        <div class="li" style="flex: 1;">
          <div class="li_tit">
            <div class="name">同期对比</div>
            <div class="txt">At the same time comparing</div>
          </div>
          <div class="users panel">
            <div class="inner">
              <div class="comparing">
                <div class="left">
                  <div class="tit">人均产值 <div class="txt">{{compareData.renjun}}</div><span
                      style=" font-size: .1rem;  ">万元</span></div>
                  <vchart style="height: 100%;" ref='comparing1'></vchart>
                  <span class="span"><i>↑</i>{{compareData.pieData}}%</span>
                </div>
                <div class="right">
                  <div class="li">
                    <div class="t">
                      <div class="n">累计出货</div>
                      <div class="ll">
                        <span class="nn">去年同期</span>
                        <span class="nt">
                          <span class="txt">{{compareData.lastleiji}}</span><span class="ren">台</span>
                        </span>
                      </div>
                    </div>
                    <div class="t">
                      <div class="n"><span class="txt">{{compareData.leiji}}</span><span class="ren">台</span></div>
                      <div class="ll">
                        <span class="nn">去年同期相比</span>
                        <span class="nt" v-if="compareStatus.leijiUp">
                          <span>▲</span><span>{{compareData.leijiRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.leijiDown">
                          <span
                            style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.leijiRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.leijiTie">
                          <span class="n">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="li">
                    <div class="t">
                      <div class="n">车间在产数量</div>
                      <div class="ll">
                        <span class="nn">去年同期</span>
                        <span class="nt">
                          <span class="txt">{{compareData.lastchanshu}}</span><span class="ren">台</span>
                        </span>
                      </div>
                    </div>
                    <div class="t">
                      <div class="n"><span class="txt">{{compareData.zaichanshu}}</span><span class="ren">台</span></div>
                      <div class="ll">
                        <span class="nn">去年同期相比</span>
                        <span class="nt" v-if="compareStatus.chanshuUp">
                          <span>▲</span><span>{{compareData.chanshuRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.chanshuDown">
                          <span
                            style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.renshuRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.chanshuTie">
                          <span class="n">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="li">
                    <div class="t">
                      <div class="n">车间人数</div>
                      <div class="ll">
                        <span class="nn">去年同期</span>
                        <span class="nt">
                          <span class="txt">{{compareData.lastrenshu}}</span><span class="ren">人</span>
                        </span>
                      </div>
                    </div>
                    <div class="t">
                      <div class="n"><span class="txt">{{compareData.renshu}}</span><span class="ren">人</span></div>
                      <div class="ll">
                        <span class="nn">去年同期相比</span>
                        <span class="nt" v-if="compareStatus.renshuUp">
                          <span>▲</span><span>{{compareData.renshuRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.renshuDown">
                          <span
                            style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.renshuRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.renshuTie">
                          <span class="n">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="li">
                    <div class="t">
                      <div class="n">已签合同</div>
                      <div class="ll">
                        <span class="nn">去年同期</span>
                        <span class="nt">
                          <span class="txt">{{compareData.lasthetong}}</span><span class="ren">个</span>
                        </span>
                      </div>
                    </div>
                    <div class="t">
                      <div class="n"><span class="txt">{{compareData.hetong}}</span><span class="ren">个</span></div>
                      <div class="ll">
                        <span class="nn">去年同期相比</span>
                        <span class="nt" v-if="compareStatus.hetongUp">
                          <span>▲</span><span>{{compareData.hetongRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.hetongDown">
                          <span
                            style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.hetongRate}}%</span>
                        </span>
                        <span class="nt" v-if="compareStatus.hetongTie">
                          <span class="n">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    </span>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart
    },
    data() {
      return {
        nianyue: '',
        xinqi: '',
        timed: '',//时间
        tianqi: '',//天气
        yongneng: {
          dayValue: 0,
          lastDayValue: 0,
          dayRate: 0,
          monthMaxValue: 0,
          lastMonthValue: 0,
          monthValue: 0,
          yearValue: 0,
          lastYearValue: 0,
          yearRate: 0
        },
        cainian: {
          leijihetong: 0,
          leijijine: 0,
          leijichanping: 0,
        },
        producingNum: { pdx: 0, gyg: 0, dyg: 0 },//在产数量
        workShopNum: { gyg: 0, dyg: 0, bj: 0, mxc: 0, pdx: 0, renshu: 0, total: 0 },//车间人数
        compareData: {
          renjun: 0, pieData: 0, leiji: 0, lastleiji: 0, renshu: 0, lastrenshu: 0, zaichanshu: 0, lastchanshu: 0, hetong: 0, lasthetong: 0,
          leijiRate: 0, chanshuRate: 0, renshuRate: 0, hetongRate: 0
        },//同期对比
        compareStatus: {
          leijiUp: false, leijiDown: false, leijiTie: false, chanshuUp: false, chanshuDown: false, chanshuTie: false,
          renshuUp: false, renshuDown: false, renshuTie: false, hetongUp: false, hetongDown: false, hetongTie: false
        },//同期对比状态
        dayUp: false,
        dayDown: false,
        dayTie: false,
        monthUp: false,
        monthDown: false,
        monthTie: false,
        yearUp: false,
        yearDown: false,
        yearTie: false,
        dayRateShow: true,
        monthRateShow: true,
        yearRateShow: true,
        fenxiang: [],//分项
        chanzhiOption: {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度
            itemHeight: 10, // 设置高度
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '11%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.getMonth(),
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              boundaryGap: false,
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            },
            {
              type: 'value',
              //postiton:'right',
              boundaryGap: false,
              max: function (value) {
                return (value.max).toFixed(2) + 2;
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#3996DF', '#CB8429', '#0C6DEE'],
          series: [
            {
              name: '电耗',
              type: 'line',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0B6FF7'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [130, 142, 151, 164, 90, 270, 110, 90, 140, 110, 20, 210]
            },
            {
              name: '产能比',
              type: 'line',
              smooth: true,
              yAxisIndex: 1,
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#CB8429'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [20, 132, 141, 154, 90, 230, 610, 90, 260, 170, 280, 30]
            },
            {
              name: '产值',
              type: 'line',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0C6DEE'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [100, 102, 201, 134, 90, 230, 210, 90, 540, 410, 140, 210]
            }
          ]
        },//产值option
        loadOption: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '18%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xList(),
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          yAxis: [
            {
              name: 'kw',
              type: 'value',
              boundaryGap: false,
              max: function (value) {
                return (value.max + 100).toFixed(2);
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#0B6FF7'],
          series: [
            {
              type: 'line',
              stack: 'Total',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0B6FF7'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [120, 132, 101, 134, 90, 230, 210, 90, 240, 110, 240, 110]
            }
          ]
        },//负荷option
        monthSellOption: {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度
            itemHeight: 10, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '5%',
            bottom: '4%',
            top: '15%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: this.getMonth(),
              // 使用数据的值设为刻度文字
              type: 'category',

              //文字
              axisLabel: {
                color: '#667079'
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }
          ],
          // 控制y轴
          yAxis: [
            {
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#1e74bb', '#58b6df', '#cb8429'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置
              showBackground: true,
              // 图表数据名称
              name: '配电箱',

              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [11, 331, 7]
            },
            {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: '高压柜',
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 311, 45]
            }, {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: '低压柜',
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [31, 131, 337]
            }
          ]
        },//月出货
        undeliveryOption: {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度
            itemHeight: 10, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '5%',
            bottom: '4%',
            top: '25%',

            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: this.getMonth(),
              // 使用数据的值设为刻度文字
              type: 'category',

              //文字
              axisLabel: {
                color: '#fff'
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              name: '数量',
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#fff'
              }
            }
          ],
          color: ['#1e74bb', '#cb8429', '#58b6df'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置
              // 图表数据名称
              name: '已签',

              // 图表类型
              type: 'bar',
              barGap: 0,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 数据
              data: [11, 331, 7]
            },
            {
              // series配置
              // 图表数据名称
              name: '未交',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 311, 45]
            }
          ]
        },//未交货数量
        fenbuOption: {
          tooltip: {
            trigger: 'item',
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "台";
            },
          },
          legend: {
            bottom: '1%',
            left: 'right',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 9, // 设置宽度
            itemHeight: 9, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#ccc'//字体颜色
            },
          },
          color: ["#0b71f7", "#a2f6fe", "#57cfff", "#fbd437"],
          series: [
            {
              name: "在产数量",
              type: 'pie',
              radius: ['35%', '60%'],
              center: ['61%', '40%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#010305',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: '{b}\n{d}%',
                color: '#fff',//字体颜色
                fontSize: 12,
              },
              emphasis: {
                label: {
                  show: true,
                  formatter: '{b}\n{d}%',
                  fontSize: '16',

                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: 589, name: '配电箱' },
                { value: 325, name: '高压柜' },
                { value: 265, name: '低压柜' },
              ]
            }
          ]
        },//在产数量
      }
    },
    computed: {

    },
    watch: {
      'yongneng.dayValue'(nv, ov) {
        console.log(nv, 'dayValue')
        this.dayRate();
      },
      'yongneng.lastDayValue'(nv, ov) {
        console.log(nv, 'lastdayValue')
        this.dayRate();
      },
      'yongneng.monthValue'(nv, ov) {
        this.monthRate();
      },
      'yongneng.lastMonthValue'(nv, ov) {
        this.monthRate();
      },
      'yongneng.yearValue'(nv, ov) {
        this.yearRate();
      },
      'yongneng.lastYearValue'(nv, ov) {
        this.yearRate();
      }

      // yongneng:{
      //   handler: (nv,ov) => {
      //     console.log(nv,'yongneng')
      //   },
      //   deep:true
      // }


    },
    mounted() {
      //获取实时值
      //this.getRealTimeValue();
      setFz();
      //  屏幕的宽度改变之后 
      window.onresize = function () {
        setFz();
      }
      function setFz() {
        /* 
        1 获取到当前的屏幕的宽度  =  要适配的屏幕的宽度
        2 计算html字体的大小   fontsize=基础值 * 要适配的屏幕的宽度 /  设计稿的宽度
        3 打开页面 直接调用该方法  屏幕的宽度改变之后 再调用一次这个方法 就可以动态改变html的字体
         */
        // 当前屏幕的宽度
        var screenWidth = document.querySelector("html").offsetWidth;
        // 基础值
        var baseVal = 100;
        // 设计稿的宽度
        var pageWidth = 1920;
        // 字体大小
        var fz = baseVal * screenWidth / pageWidth;
        document.querySelector("html").style.fontSize = fz + "px";
      }
      setInterval(() => {
        this.nianyue = this.parseTime(new Date(), '{y}/{m}/{d}');
        this.xinqi = this.parseTime(new Date(), '星期{a}');
        this.timed = this.parseTime(new Date(), '{h}：{i}：{s}');
      }, 1000);
      var url = encodeURI("http://wthrcdn.etouch.cn/weather_mini?city=珠海市");
      $.get({
        url: url,
        dataType: "json",
        async: false,
        success: (data) => {
          var d = data.data.forecast[0];
          var e = new Date().getDay()
          this.tianqi = d.type + ', ' + d.high.slice(3, 5) + '~' + d.low.slice(-3);
        }
      })
      // "高温 27℃" slice(), d
      //滚动

      // 在产数量
      //this.fenbu();
      // 同期对比
      this.comparing();
      // 产值能耗比
      //this.consumption();
      // 负荷曲线
      //this.curve();
      // 月出货量
      this.yonghu();
      // 未交货数
      this.Unfilled();
      // 定单
      this.dingdan();
      // mounte里隐藏边框
      this.$store.menuStore.commit("setTopMenuEnable", false)
      this.$store.menuStore.commit("setLeftMenuEnable", false)

    },
    destroyed() {
      this.$store.menuStore.commit("setTopMenuEnable", true)
      this.$store.menuStore.commit("setLeftMenuEnable", true)
    },
    created() {
      //获取用电概况数据
      this.getUnitUseTimePowerByDate();
      //定时循环获取用电情况
      this.setIntervalGetUnitUseTimePowerByDate();
      //获取分项能耗
      this.getEnergyTypeRanking();
      //获取当月每天电耗值
      this.getPowerMonthResult();
      //获取当天负荷值
      this.getTodayLoadValues();
      //当天负荷值定时循环
      this.setIntervalGetTodayLoadValues();
      //获取月出货数据
      //this.getMonthShellNum();
      //获取未交货数
      //this.getMonthUndeliveryNum();
      //获取实时值
      this.getRealTimeValue();
    },
    methods: {
      dayRate() {
        this.dayTie = false;
        this.dayUp = false;
        this.dayDown = false;
        let result = this.compareValue(this.yongneng.dayValue, this.yongneng.lastDayValue);
        console.log(result, 'result')
        if (result == 0) {
          this.dayTie = true;
          this.dayRateShow = false;
        } else if (result > 0) {
          this.dayUp = true;
          this.dayRateShow = true;
        } else {
          this.dayDown = true;
          this.dayRateShow = true;
        }
        this.yongneng.dayRate = result + '%';
        //return result+'%';
      },
      monthRate() {
        this.monthTie = false;
        this.monthUp = false;
        this.monthDown = false;
        let result = this.compareValue(this.yongneng.monthValue, this.yongneng.lastMonthValue);
        if (result == 0) {
          this.monthTie = true;
          this.monthRateShow = false;
        } else if (result > 0) {
          this.monthUp = true;
          this.monthRateShow = true;
        } else {
          this.monthDown = true;
          this.monthRateShow = true;
        }
        this.yongneng.monthRate = result + '%';
      },
      yearRate() {
        this.yearTie = false;
        this.yearUp = false;
        this.yearDown = false;
        let result = this.compareValue(this.yongneng.yearValue, this.yongneng.lastYearValue);
        if (result == 0) {
          this.yearTie = true;
          this.yearRateShow = false;
        } else if (result > 0) {
          this.yearUp = true;
          this.yearRateShow = true;
        } else {
          this.yearDown = true;
          this.yearRateShow = true;
        }
        this.yongneng.yearRate = result + '%';
      },
      compareValue(a, b) {
        if (a == 0 || b == 0 || a == undefined || b == undefined) {
          return 0
        }
        return cutDigital((a - b) / b * 100)
      },
      setIntervalGetUnitUseTimePowerByDate() {
        setInterval(() => { this.getUnitUseTimePowerByDate() }, 4 * 60 * 60 * 1000)
      },
      setIntervalGetTodayLoadValues() {
        //this.getTodayLoadValues()
        setInterval(() => { this.getTodayLoadValues() }, 60 * 60 * 1000);
        //setInterval(() => {this.getUnitUseTimePowerByDate()},4*60*60*1000)
      },
      getRealTimeValue() {
        //财年数据
        this.$api.realApi.getMACRealValueWithID('财年累计合同数,财年累计合同额,财年累计产品数', '', res => {
          let strArr = res.data.split(";");
          this.cainian.leijihetong = strArr[0];
          this.cainian.leijijine = strArr[1];
          this.cainian.leijichanping = strArr[2];
        })
        //获取在产数量
        this.$api.realApi.getMACRealValueWithID('在产数量.配电箱,在产数量.高压柜,在产数量.低压柜', '', res => {
          let strArr = res.data.split(";");
          this.producingNum.pdx = strArr[0];
          this.producingNum.gyg = strArr[1];
          this.producingNum.dyg = strArr[2];
          let data = [];
          data.push({ value: strArr[0], name: '配电箱' });
          data.push({ value: strArr[1], name: '高压柜' });
          data.push({ value: strArr[2], name: '低压柜' });
          this.fenbuOption.series[0].data = data;
          this.$refs.vchart2.setData(this.fenbuOption, true);
        })
        //获取车间人数
        this.$api.realApi.getMACRealValueWithID('车间人数.高低压车间,车间人数.配电箱车间,车间人数.母线铜排车间,车间人数.钣金车间', '', res => {
          let strArr = res.data.split(";");
          this.workShopNum.gyg = strArr[0];
          this.workShopNum.dyg = strArr[1];
          this.workShopNum.bj = strArr[2];
          this.workShopNum.mxc = strArr[3];
          this.workShopNum.pdx = strArr[4];
          this.workShopNum.total = Number(strArr[0]) + Number(strArr[1]) + Number(strArr[2]) + Number(strArr[3]) + Number(strArr[4]);

        })
        //同期对比
        this.$api.realApi.getMACRealValueWithID('同期对比.人均产值,同期对比.增长率,同期对比.累计出货,同期对比.去年同期出货,同期对比.在产数,同期对比.去年在产数,' +
          '同期对比.车间人数,' + '同期对比.去年车间人数,同期对比.已签合同,同期对比.去年已签合同', '', res => {
            let strArr = res.data.split(";");
            this.compareData.renjun = strArr[0];     //人均产值
            this.compareData.pieData = strArr[1];    //增长率
            this.compareData.leiji = strArr[2];      //累计出货
            this.compareData.lastleiji = strArr[3];  //去年累计出货
            this.compareData.renshu = strArr[6];  //车间人数
            this.compareData.lastrenshu = strArr[7]; //去年同期人数
            this.compareData.zaichanshu = strArr[4]; //同期在产数
            this.compareData.lastchanshu = strArr[5];//去年在产数
            this.compareData.hetong = strArr[8];     //已签合同
            this.compareData.lasthetong = strArr[9]; //去年已签合同

            //计算比例
            //在产数
            let chanshuCha = Number(strArr[4]) - Number(strArr[5]);//产数差值
            if (isempty(strArr[5]) || Number(strArr[5]) == 0) {
              this.compareStatus.chanshuTie = true;
            } else {
              if (chanshuCha > 0) {
                this.compareStatus.chanshuUp = true;
              } else if (chanshuCha < 0) {
                this.compareStatus.chanshuDown = true;
              } else {
                this.compareStatus.chanshuTie = true;
              }
              this.compareData.chanshuRate = ((Math.abs(chanshuCha / strArr[5])) * 100).toFixed(2);
            }
            //出货
            let leijiCha = Number(strArr[2]) - Number(strArr[3]);//出货差值
            //debugger
            if (isempty(strArr[3]) || Number(strArr[3]) == 0) {
              this.compareStatus.leijiTie = true;
            } else {
              if (leijiCha > 0) {
                this.compareStatus.leijiUp = true;
              } else if (leijiCha < 0) {
                this.compareStatus.leijiDown = true;
              } else {
                this.compareStatus.leijiTie = true;
              }
              this.compareData.leijiRate = ((Math.abs(leijiCha / strArr[3])) * 100).toFixed(2);
            }
            //车间人数
            let renshuCha = Number(strArr[6]) - Number(strArr[7]);//人数差值
            if (isempty(strArr[7]) || Number(strArr[7]) == 0) {
              this.compareStatus.renshuTie = true;
            } else {
              if (renshuCha > 0) {
                this.compareStatus.renshuUp = true;
              } else if (renshuCha < 0) {
                this.compareStatus.renshuDown = true;
              } else {
                this.compareStatus.renshuTie = true;
              }
              this.compareData.renshuRate = ((Math.abs(renshuCha / strArr[7])) * 100).toFixed(2);
            }
            //合同数
            let hetongCha = Number(strArr[8]) - Number(strArr[9]);//人数差值
            if (isempty(strArr[9]) || Number(strArr[9]) == 0) {
              this.compareStatus.hetongTie = true;
            } else {
              if (hetongCha > 0) {
                this.compareStatus.hetongUp = true;
              } else if (hetongCha < 0) {
                this.compareStatus.hetongDown = true;
              } else {
                this.compareStatus.hetongTie = true;
              }
              this.compareData.hetongRate = ((Math.abs(hetongCha / strArr[9])) * 100).toFixed(2);
            }

          })

      },
      getMonth() {
        let d = []
        for (let i = 1; i < 13; i++) {
          d.push(i + '月')
        }
        return d;
      },
      getMonthUndeliveryNum() {
        this.$api.historyApi.searchVariableHistoryWithDateType('未交货数.已签,未交货数.未交', 'year', new Date().getTime(), res => {
          let yq = [];
          let wj = [];
          if (!isempty(res['未交货数.已签'])) {
            res['未交货数.已签'].forEach(item => {
              if (isempty(item.dataSum)) {
                yq.push(item.dataSum);
              } else {
                yq.push(null);
              }
            })
          }
          if (!isempty(res['未交货数.未交'])) {
            res['未交货数.未交'].forEach(item => {
              if (isempty(item.dataSum)) {
                wj.push(item.dataSum);
              } else {
                wj.push(null);
              }
            })
          }
          this.undeliveryOption.series[0].data = yq;
          this.undeliveryOption.series[1].data = wj;
          this.$refs.Unfilled1.setData(this.undeliveryOption, true);
        });
      },
      getMonthShellNum() {
        this.$api.historyApi.searchVariableHistoryWithDateType('月出货.配电箱,月出货.高压柜,月出货.低压柜', 'year', new Date().getTime(), res => {
          let pdx = [];
          let gyg = [];
          let dyg = [];
          if (!isempty(res['月出货.配电箱'])) {
            res['月出货.配电箱'].forEach(item => {
              if (isempty(item.dataSum)) {
                pdx.push(item.dataSum);
              } else {
                pdx.push(null);
              }
            })
          }
          if (!isempty(res['月出货.高压柜'])) {
            res['月出货.高压柜'].forEach(item => {
              if (isempty(item.dataSum)) {
                gyg.push(item.dataSum);
              } else {
                gyg.push(null);
              }
            })
          }
          if (!isempty(res['月出货.配电箱'])) {
            res['月出货.配电箱'].forEach(item => {
              if (isempty(item.dataSum)) {
                dyg.push(item.dataSum);
              } else {
                dyg.push(null);
              }
            })
          }
          this.monthSellOption.series[0].data = pdx;
          this.monthSellOption.series[1].data = gyg;
          this.monthSellOption.series[2].data = dyg;
          this.$refs.vchart1.setData(this.monthSellOption, true);
        });
      },
      //每小时执行一次
      getTodayLoadValues() {
        this.$api.powerApi.getUnitDayLoadValues('', new Date(getDay(0) + ' 00:00:00').getTime(), res => {
          let loadValues = [];
          if (!isempty(res)) {
            for (let i = 0; i < res.length; i += 12) {
              loadValues.push(res[i]);
            }
          }
          this.loadOption.series[0].data = loadValues;
          this.$refs.curve1.setData(this.loadOption, true);
        })
      },
      getPowerMonthResult() {
        let day = new Date().getDate();
        console.log(day, "day")
        this.$api.powerApi.getPowerMonthResult(new Date().getTime(), '产值', res => {
          let sumArr = [];//电耗
          let chanzhiArr = [];//产值
          let rate = [];//比例
          for (const key in res) {
            if (key != '产值') {
              if (!isempty(sumArr)) {
                if (!isempty(res[key][0].data)) {
                  //for(let i=0;i<res[key][0].data.length;i++) {
                  for (let i = 0; i < day; i++) {
                    if (!isempty(res[key][0].data[i])) {
                      sumArr[i] = sumArr[i] + res[key][0].data[i]
                    }
                  }
                }
              } else {
                sumArr = res[key][0].data.slice(0, day)
              }
            } else {
              if (!isempty(res[key][0].data)) {
                chanzhiArr = res[key][0].data.slice(0, day);
              }
            }
          }
          console.log(sumArr, "电能");
          console.log(chanzhiArr, "产值")
          //计算产值比
          if (!isempty(sumArr) && !isempty(chanzhiArr)) {
            for (let i = 0; i < sumArr.length; i++) {
              if (!isempty(sumArr[i]) && !isempty(chanzhiArr[i])) {
                rate.push(Number((chanzhiArr[i] / sumArr[i]).toFixed(2)))
                sumArr[i] = Number(sumArr[i].toFixed(2));
                chanzhiArr[i] = Number(chanzhiArr[i].toFixed(2));
              } else {
                rate.push(null);
              }
              //保留两位小数
              // debugger;
            }
          }
          // for(let i=0;i<sumArr.length;i++) {
          //   if(!isempty(sumArr[i])) {
          //     sumArr[i] =  Number(sumArr[i].toFixed(2));
          //   }
          // }

          console.log(sumArr, "总能耗")
          this.chanzhiOption.series[0].data = sumArr;
          this.chanzhiOption.series[1].data = rate;
          this.chanzhiOption.series[2].data = chanzhiArr;
          this.$refs.consumption1.setData(this.chanzhiOption, true);
        })
      },
      xList() {
        let list = []
        for (let h = 0, len = 24; h < len; h++) {
          list.push((h < 10 ? '0' : '') + h + ':00')
        }
        return list
      },
      getDateFormat() {
        let a = [];
        let y = new Date().getFullYear();
        let m = new Date().getMonth() + 1;
        let d = new Date(y, m, 0).getDate() + 1;
        let mm = m > 10 ? m : 0 + m;
        for (let i = 1; i < d; i++) {
          let ii = i > 10 ? i : '0' + i;
          a.push(mm + '/' + ii)
        }
        return a;
      },
      getEnergyTypeRanking() {
        this.$api.powerApi.getEnergyTypeRanking(new Date().getTime(), 'day', res => {
          this.fenxiang = res;
        })
      },
      getUnitUseTimePowerByDate() {
        let now = new Date();
        let nowTime = now.getTime();
        let year = now.getFullYear();
        let month = now.getMonth();
        let day = now.getDate();
        let nowZero = new Date(year, month, day).getTime();
        //获取今年电量
        this.$api.powerApi.getUnitUsePowerByDate('', new Date(year, 0, 1).getTime(), nowTime, res => {
          this.yongneng.yearValue = Number(res);
          if (month == 0) {
            this.yongneng.monthValue = Number(res);
          }

        })
        //获取今日电量
        this.$api.powerApi.getUnitUsePowerByDate('', nowZero, nowTime, res => {
          this.yongneng.dayValue = Number(res);
          if (day == 1) {
            this.yongneng.monthValue = Number(res);
          }
        })
        //获取昨日电量
        this.$api.powerApi.getUnitUsePowerByDate('', nowZero - 24 * 60 * 60 * 1000, nowTime - 24 * 60 * 60 * 1000, res => {
          this.yongneng.lastDayValue = Number(res);
        })
        //获取上月同期电量
        let lastMonthDate = new Date(year, month - 1, day)
        let lastMonthZeroDate = new Date(year, month - 1, 1)
        this.$api.powerApi.getUnitUsePowerByDate('', lastMonthZeroDate.getTime(), lastMonthDate.getTime(), res => {
          this.yongneng.lastMonthValue = Number(res);
        })
        //获取本月电量
        this.$api.powerApi.getUnitUsePowerByDate('', new Date(year, month, 1).getTime(), nowTime, res => {
          this.yongneng.monthValue = Number(res);
        })
        //获取去年同期电量
        this.$api.powerApi.getUnitUsePowerByDate('', new Date(year - 1, 0, 1).getTime(), new Date(year - 1, month, day).getTime(), res => {
          this.yongneng.lasstYearValue = Number(res);
        })
        // this.$api.powerApi.getUnitUseTimePowerByDate(new Date().getTime(),res => {
        //     this.yongneng.dayValue = res.dayValue;
        //     this.yongneng.lastDayValue = res.lastDayValue;
        //     if(res.lastDayValue == 0) {
        //       this.yongneng.dayRate = 0;
        //     }else{
        //       this.yongneng.dayRate = (((res.dayValue - res.lastDayValue)/(res.lastDayValue<1?1:res.lastDayValue))*100).toFixed(2);
        //     }
        //
        //     if(this.yongneng.dayRate > 0) {
        //       this.dayUp = true;
        //     }else if(this.yongneng.dayRate <0) {
        //       this.dayDown = true;
        //     }else {
        //       this.dayTie = true;
        //     }
        //     this.yongneng.monthValue = res.monthValue;
        //     this.yongneng.lastMonthValue = res.lastMonthValue;
        //     if(res.lastMonthValue == 0) {
        //       this.yongneng.monthRate = 0;
        //     }else {
        //       this.yongneng.monthRate = ((res.monthValue - res.lastMonthValue)/(res.lastMonthValue<1?1:res.lastMonthValue)*100).toFixed(2);
        //     }
        //   if(this.yongneng.monthRate > 0) {
        //     this.monthUp = true;
        //   }else if(this.yongneng.monthRate <0) {
        //     this.monthDown = true;
        //   }else {
        //     this.monthTie = true;
        //   }
        //     this.yongneng.yearValue = res.yearValue;
        //     this.yongneng.lastYearValue = res.lastYearValue;
        //     if(res.lastYearValue == 0) {
        //       this.yongneng.yearRate = 0
        //     }else {
        //       this.yongneng.yearRate = ((res.yearValue - res.lastYearValue)/(res.lastYearValue<1?1:res.lastYearValue)*100).toFixed(2);
        //     }
        //   if(this.yongneng.yearRate > 0) {
        //     this.yearUp = true;
        //   }else if(this.yongneng.yearRate <0) {
        //     this.yearDown = true;
        //   }else {
        //     this.yearTie = true;
        //   }
        // })
      },
      parseTime(time, cFormat) {
        if (arguments.length === 0) {
          return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
          }
          if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
          }
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
          const value = formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
          return value.toString().padStart(2, '0')
        })
        return time_str
      },
      // 未交货数
      Unfilled() {
        var d = []
        for (let i = 1; i < 13; i++) {
          d.push(i + '月')
        }

        var option = {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '5%',
            bottom: '4%',
            top: '25%',

            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: d,
              // 使用数据的值设为刻度文字
              type: 'category',

              //文字
              axisLabel: {
                color: '#fff'
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              name: '数量',
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#fff'
              }
            }
          ],
          color: ['#1e74bb', '#cb8429', '#58b6df'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置 
              // 图表数据名称
              name: '已签',

              // 图表类型
              type: 'bar',
              barGap: 0,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 数据
              data: [11, 331, 7, 38, 112, 48, 74]
            },
            {
              // series配置 
              // 图表数据名称
              name: '未交',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 311, 45, 189, 47, 93, 12]
            }
          ]
        };

        this.$refs.Unfilled1.setData(option, true);


      },
      // 月出货量
      yonghu() {
        var d = []
        for (let i = 1; i < 13; i++) {
          d.push(i + '月')
        }

        var option = {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '5%',
            bottom: '4%',
            top: '15%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: d,
              // 使用数据的值设为刻度文字
              type: 'category',

              //文字
              axisLabel: {
                color: '#667079'
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#1e74bb', '#58b6df', '#cb8429'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置
              showBackground: true,
              // 图表数据名称
              name: '配电箱',

              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [11, 331, 7, 45, 112, 16, 91]
            },
            {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: '高压柜',
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 311, 49, 75, 112, 63, 94]
            }, {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: '低压柜',
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [31, 131, 337, 17, 118, 19, 69]
            }
          ]
        };
        this.$refs.vchart1.setData(option, true);
      },
      //产值能耗比
      consumption(data) {

        var option = option = {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10,  // 设置宽度 
            itemHeight: 10, // 设置高度
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '11%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: ['07/08', '07/11', '07/14', '07/17', '07/20', '07/23', '07/26', '07/29'],
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              boundaryGap: false,
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#3996DF', '#CB8429', '#0C6DEE'],
          series: [
            {
              name: '电耗',
              type: 'line',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0B6FF7'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [130, 142, 151, 164, 90, 270, 110, 90, 140, 110, 20, 210]
            },
            {
              name: '月平均',
              type: 'line',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#CB8429'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [20, 132, 141, 154, 90, 230, 610, 90, 260, 170, 280, 30]
            },
            {
              name: '产值',
              type: 'line',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0C6DEE'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [100, 102, 201, 134, 90, 230, 210, 90, 540, 410, 140, 210]
            }


          ]
        };
        //获取当月每天电耗数据
        this.$refs.consumption1.setData(option, true);
      },

      // 负荷曲线
      curve() {
        var option = option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '18%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00',],
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          yAxis: [
            {
              name: 'kw',
              type: 'value',
              boundaryGap: false,
              max: function (value) {
                return (value.max).toFixed(2) + 100;
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: '#667079'
              }
            }
          ],
          color: ['#0B6FF7'],
          series: [
            {
              type: 'line',
              stack: 'Total',
              smooth: true,
              //areaStyle: {},
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0B6FF7'
                  },
                  {
                    offset: 1,
                    color: 'rgba(1, 191, 236,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [120, 132, 101, 134, 90, 230, 210, 90, 240, 110, 240, 110]
            }

          ]
        };
        this.$refs.curve1.setData(option, true);
      },

      // 在产数量
      fenbu() {
        var option = {
          tooltip: {
            trigger: 'item',
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "台";
            },
          },
          legend: {
            bottom: '1%',
            left: 'right',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 9, // 设置宽度
            itemHeight: 9, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#ccc'//字体颜色
            },

          },
          color: ["#0b71f7", "#a2f6fe", "#57cfff", "#fbd437"],
          series: [
            {
              name: "在产数量",
              type: 'pie',
              radius: ['35%', '60%'],
              center: ['61%', '40%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#010305',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: '{b}\n{d}%',
                color: '#fff',//字体颜色  
                fontSize: 12,
              },
              emphasis: {
                label: {
                  show: true,
                  formatter: '{b}\n{d}%',
                  fontSize: '16',

                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: 589, name: '配电箱' },
                { value: 325, name: '高压柜' },
                { value: 265, name: '低压柜' },
              ]
            }
          ]
        };
        this.$refs.vchart2.setData(option, true);
      },
      // 同期对比
      comparing() {
        var option = {
          color: ["#0269e9", "#a1f3fc", "#01f5f6", "#00cfff"],
          series: [
            {
              name: "在产数量",
              type: 'pie',
              radius: ['60%', '78%'],
              center: ['50%', '49%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#010305',
                borderWidth: 2
              },
              label: {
                show: false,
                formatter: '{b}\n{d}%',
                color: '#fff',//字体颜色  
                fontSize: 12,
              },
              emphasis: {
                label: {
                  show: false,
                  formatter: '{b}\n{d}%',
                  fontSize: '16',

                }
              },
              data: [
                { value: 589, name: '配电箱' },
                { value: 589, name: '配电箱' },
                { value: 325, name: '高压柜' },
                { value: 265, name: '低压柜' },
              ]
            }
          ]
        };
        this.$refs.comparing1.setData(option, true);
      },
      // 定单
      dingdan() {
        var data = {
          day365: { orders: '20,301,987', amount: '99834' },
          day90: { orders: '301,987', amount: '9834' },
          day30: { orders: '1,987', amount: '3834' },
          day1: { orders: '987', amount: '834' }
        }
        //点击事件
        $('.order').on('click', '.filter a', function () {
          //点击之后加类名
          $(this).addClass('active').siblings().removeClass('active');
          // 先获取点击a的 data-key自定义属性
          var key = $(this).attr('data-key');
          //获取自定义属性
          // data{}==>data.shuxing data['shuxing]
          key = data[key];//
          $('.order .item h4:eq(0)').text(key.orders);
          $('.order .item h4:eq(1)').text(key.amount);
        });
        //定时器
        var index = 0;
        var aclick = $('.order a');
        setInterval(function () {
          index++;
          if (index > 3) {
            index = 0;
          }
          //每san秒调用点击事件
          aclick.eq(index).click();
        }, 3000);
      },
    },
  };
</script>

<style>
  html * {
    user-select: text !important;
  }

  .column .map {
    position: relative;
    height: 95.3%;
  }

  .column .map .m_box {
    position: absolute;
    top: 0;
    left: 0;
  }

  .column .map .m_box .li {
    width: 2.14rem;
    height: .98rem;
    background: #1B1B1B;
    border: 1px solid #BFBFBF;
    opacity: 0.82;
    margin-top: 0.2rem;
    margin-left: 0.47rem;
    position: relative;
  }

  .column .map .m_box .li .left {
    position: absolute;
    left: -1px;
    top: -1px;
    width: 0.2rem;
    height: 0.22rem;
    border-top: 2px solid #0B71F7;
    border-left: 2px solid #0B71F7;
  }

  .column .map .m_box .li .right {
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: 0.2rem;
    height: 0.22rem;
    border-right: 1px solid #0B71F7;
    border-bottom: 1px solid #0B71F7;
  }

  .column .map .m_box .t {
    line-height: .35rem;
    font-size: .21rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFF;
    padding-left: .24rem;
  }

  .column .map .li .x {
    display: flex;
    justify-content: space-between;
    padding: 0 .2rem;
    margin-top: .2rem;
  }

  .column .map .li .x span {
    font-size: .25rem;
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-style: italic;
    color: #FFF;
  }

  .column .map .li .x .txt {
    font-size: .46rem;
    font-family: Klavika Medium;
    font-weight: normal;
    color: #1980D6;
    font-style: italic;
    font-weight: bold;
  }

  /* 同期对比 */
  .comparing .span {
    position: absolute;
    color: #fff;
    left: 0.8rem;
    top: 0.8rem;
    font-size: .25rem;
    font-family: fantasy;
    font-style: italic;
  }

  .comparing .span i {
    font-family: fantasy;
    font-style: initial;
    display: inline-block;
    font-size: 21px;
    -webkit-transform: translate(11px, -13px);
    transform: translate(5px, -13px);
  }

  .comparing {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .comparing .left {
    width: 2.1rem;
    margin-right: .1rem;
  }

  .comparing .left .tit {
    display: flex;
    justify-content: center;
    font-size: .17rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #F0F0F0;
  }

  .comparing .left .tit .txt {
    font-size: .25rem;
    font-family: Klavika Medium;
    font-weight: normal;
    color: #1980D6;
    margin-left: .13rem;
    font-style: italic;
    margin-right: 0.05rem;
  }

  .comparing .right {
    display: flex;
    color: #F0F0F0;
    flex-wrap: wrap;
    flex: 1;
    padding-right: 13px;
  }

  .comparing .right .li {
    display: flex;
    flex-direction: column;
    width: 3.19rem;
  }

  .comparing .right .li:nth-child(1) {
    box-sizing: border-box;
    border-right: 1px solid #5F6162;
    border-bottom: 1px solid #5F6162;
    padding-bottom: 10px;
    padding-right: 0.17rem;
  }

  .comparing .right .li:nth-child(2) {
    box-sizing: border-box;
    border-bottom: 1px solid #5F6162;
    padding-bottom: 10px;
    padding-left: 13px;
  }

  .comparing .right .li:nth-child(3) {
    box-sizing: border-box;
    border-right: 1px solid #5F6162;
    margin-top: 10px;
    padding-right: 0.17rem;
  }

  .comparing .right .li:nth-child(4) {
    margin-top: 10px;
    padding-left: 13px;
    box-sizing: border-box;
  }

  .comparing .right .li .t {
    display: flex;
    margin-bottom: .06rem;
  }

  .comparing .right .li .t .n {
    width: 1.5rem;
    font-size: .17rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  .comparing .right .li .t .ll {
    width: 2.5rem;
    height: 24px;
    background: #101215;
    font-size: .13rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #F1F1F1;
  }

  .comparing .right .li .t .ll .nn {
    font-size: .13rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    padding-left: .1rem;
    width: 1rem;
    display: inline-block;
  }

  .comparing .right .li .t .ll .nt {
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1980D6;
  }

  .comparing .right .li .t .ll .nt .ren {
    font-size: .12rem;
    color: #F1F1F1;
  }

  .comparing .right .li .t .txt {
    font-size: .17rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1980D6;
  }

  .comparing .right .li .t .txt .ren {
    font-size: .16rem;
  }




  /* 分项能耗 */
  .Itemized {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding: 10px 0;
  }

  .Itemized .p {
    display: flex;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #DADADA;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 15px;
  }

  .Itemized .p:nth-child(2) .jindu .n {
    background: #57cfff;
  }

  .Itemized .p:nth-child(3) .jindu .n {
    background: #a2f6fe;
  }

  .Itemized .p:nth-child(4) .jindu .n {
    background: #cb8429;
  }

  .Itemized .p:nth-child(5) .jindu .n {
    background: #1ab49c;
  }

  .Itemized .p .name {
    width: 46px;
  }

  .Itemized .p .jindu {
    width: 79%;
    background: #101215;
    height: 10px;
    margin-right: 10px;
  }

  .Itemized .p .jindu .n {
    background: #0b71f7;
    height: 10px;
    width: 50%;
  }

  /* 用能概况 */
  .situation {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 10px 0;
  }

  .situation .p {
    display: flex;
    color: #F0F0F0;
    flex-direction: column;
    margin: 0 9px;
    padding-left: 25px;
    padding-right: 50px;
    border-bottom: 1px solid #5F6162;
  }

  .situation .p:nth-last-child(1) {
    border-bottom: none;
  }

  .situation .p div {
    display: flex;
  }

  .situation .p .top {
    height: auto;
    justify-content: space-between;
    height: .25rem;
  }

  .situation .p .bottom {
    font-size: .12rem;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #95A4B2;
    margin-bottom: 0.05rem;
  }

  .situation .p .l {
    font-size: .17rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: .07rem;
  }

  .situation .p .m {
    line-height: .26rem;
  }

  .situation .p .m .txt {
    font-size: .21rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1980D6;
    line-height: .21rem;
  }

  .situation .p .r {
    width: 27%;
    height: 23px;
    background: #101215;
    color: #EF9E35;
    align-items: center;
    justify-content: space-around;
  }

  .situation .p .Reverse {
    color: #1AB49C;
    transform: rotate(180deg);
  }

  .situation .p .none {
    color: #8B99A6;
  }

  .situation .p .Reverse .n:nth-child(2) {
    transform: rotate(180deg);
  }

  /* 在产数量 */
  .inner .xianshi {
    position: absolute;
    color: #fff;
    left: 22px;
    top: 15px;
    display: flex;
    flex-direction: column;
    line-height: 30px;
  }

  .inner .xianshi .p {
    display: flex;
    font-size: .13rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFF;
  }

  .inner .xianshi .p .txt {
    color: #1980D6;
    font-size: .21rem;
    padding: 0 .07rem;
  }

  .li {
    display: block;
  }

  .li .li_tit {
    display: flex;
    margin-bottom: .06rem;
    align-items: flex-end;
  }

  .li .li_tit .name {
    font-size: .22rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #1980D6;
    line-height: 29px;
    margin-right: .19rem;
  }

  .li .li_tit .txt {
    font-size: .14rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-style: italic;
    color: #4A545D;
  }

  /* 头部 */
  .box_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
  }

  .box_title .right {
    font-size: .16rem;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #FFF;
    width: 4.74rem;
    display: flex;
    align-items: end;
    justify-content: space-between;
  }

  .box_title .right span {
    font-size: .16rem;
    font-family: Source Han Sans CN;
    font-weight: 300;
  }

  .box_title .left {
    font-size: .32rem;
    font-family: lianmengqiyilushuaizhengruiheiti;
    font-weight: 400;
    color: #1980D6;
    border-bottom: 1px solid #1980D6;
    line-height: .44rem;
  }


  .chart_box {
    display: flex;
  }

  .chart_box>.pare {
    flex: 1;
  }

  .chart_box>.progress {
    width: 40%;
  }

  .chart_box>.progress2 {
    width: 40%;
  }

  .chart_box .progress .text {
    display: flex;
    justify-content: space-between;
    margin-bottom: .45px;
  }

  .chart_box .progress .text span {
    color: #fff;
  }

  .chart_box .progress .el-progress {
    margin-bottom: 19.5px;
  }

  .bottom_box {
    display: flex;
    overflow: hidden;
    justify-content: space-between;
  }

  .bottom_box .panel {
    flex: 1;
    margin-right: 12.495px;
  }

  .bottom_box .panel:nth-child(2) {
    margin-right: 0;
  }

  .bodyed {
    display: block;
    line-height: 1.15;
    font-size: 7.5px;
    margin: 0;
    padding: 0;
    width: 19.2rem;
    overflow-x: hidden;
    background-repeat: no-repeat;
    background-position: 0 0 / cover;
    background-color: #010305;
  }

  .bodyed>.box {
    display: block;
    /* max-width: 1920px; */
    margin: 0 auto;
    padding: 0 .3rem;
  }

  * {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  .viewport {
    /* 限定大小 */
    min-width: 1024px;
    /* max-width: 1920px; */
    margin: 0 auto;
    display: flex;
    padding-top: .1rem;
    justify-content: space-between;
  }

  .column {
    /* flex: 3; */
    width: 4.74rem;
    position: relative;
  }

  .column:nth-child(2) {
    /* flex: 4; */
    width: 8.38rem;
  }

  .panel {
    /* 边框 */
    box-sizing: border-box;
    border: 2px solid #ff000000;
    /* border-image: url('../../assets/kanban/box.png') 51 38 21 132; */
    /* border-width: 31.875px 23.745px 13.125px 82.5px; */
    border-top-width: 21px;
    border-right-width: 16px;
    border-bottom-width: 9px;
    border-left-width: 59px;
    position: relative;
    /* margin-bottom: 12.495px; */
  }

  .panel_box {
    width: 30%;
    height: 49.5px;
    padding-top: .45px;
    box-sizing: border-box;
    border: solid 1px #093552;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px 23px #03729724 inset;

  }

  .panel .inner {
    /* 装内容 */
    /* height:60px;*/
    position: absolute;
    top: -23.875px;
    right: -19.745px;
    bottom: -11.125px;
    left: -60.5px;
    padding: 13px 12px;
    display: flex;
    flex-direction: column;
    background: url('../../assets/kanban/box.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }

  .panel .inner2 {
    background: url('../../assets/kanban/box2.png');
    background-position: 2px -1px;
    background-size: 99.3% 100.9%;
  }

  .panel h3 {
    color: #fff;
    display: flex;
    padding-left: 55px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #F0F0F0;
  }

  .panel h3 .txt {
    font-size: 19px;
    font-family: Lato;
    font-weight: 400;
    color: #1980D6;
    padding-left: 10px;
  }

  /* 概览区域 */
  .overview {
    height: 68.745px;
  }

  .overview .inner {
    display: flex;
    justify-content: space-between;
  }

  .overview h4 {
    font-size: .135px;
    padding-left: 3px;
    color: #fff;
    margin-bottom: 4.995px
  }

  .overview span {
    font-size: 13.005px;
    color: #4c9bfd;
    margin-bottom: .45px;
  }



  .monitor .inner {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
  }

  .monitor .tabs {
    padding: 0 22.5px;
    margin-bottom: 11.25px;
  }

  .monitor .tabs a {
    color: #1950c4;
    font-size: 11.25px;
    padding: 0 16.875px;
  }

  .monitor .tabs a:first-child {
    border-right: 1.245px solid #00f2f1;
    padding-left: 0;
  }

  .monitor .tabs a.active {
    color: #fff;
  }

  .monitor .content {
    flex: 1;
    display: none;
    position: relative;
  }

  .monitor .head {
    background: rgba(255, 255, 255, 0.1);
    font-size: 8.745px;
    padding: 7.5px 22.5px;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;
    line-height: 1.05;
  }


  .monitor .col:nth-child(2) {
    width: 126px;
    /* 不换行 一行省略*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .monitor .col:nth-child(3) {
    width: 48px;
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }


  .monitor .row:nth-child(even) {
    background: #101215;
  }

  .monitor .row .col {
    font-size: 13px;
  }

  .monitor .row .col:nth-child(2) {
    color: #187ACD;
    text-indent: 3em;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  .monitor .row {
    line-height: 1.05;
    padding: 7.5px 22.5px;
    color: #DBDBDB;
    font-size: 7.5px;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-left: 55px;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  /* ------------------------------------------------------------动画 */
  @keyframes row {
    0% {}

    100% {
      transform: translateY(-50%);
    }
  }

  /* 调用动画 */
  .monitor .marquee {
    /* //infinite永久调用动画 */
    animation: row 10s linear infinite;
  }

  /*鼠标划入 停止动画 */
  .monitor .marquee:hover {
    animation-play-state: paused;
  }

  /* 点位 */
  .point {
    height: 180px;
  }

  .point .chart {
    display: flex;
    justify-content: space-between;
  }

  .point .pie {
    width: 100%;
    height: 147px;
    margin-left: -6px;
  }

  .point .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../assets/kanban/rect.png');
    background-size: cover;
  }

  .point h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }

  .point span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }


  /* 用户模块 */
  .users {
    height: 2.13rem;
    display: flex;
  }

  .users .chart {
    display: flex;
    margin-top: .75px;
    height: 100%;
  }

  .users .bar {
    width: 367.5px;
    height: 135px;
  }

  .users .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../assets/kanban/rect.png');
    background-size: cover;
  }

  .users h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }



  /* 订单 */
  .order {
    height: 92.505px;
  }

  .order .filter {
    display: flex;
  }

  .order .filter a {
    display: block;
    height: 11.25px;
    line-height: 1;
    padding: 0 11.25px;
    color: #1950c4;
    font-size: 11.25px;
    border-right: 1.245px solid #00f2f1;
  }

  .order .filter a:first-child {
    padding-left: 0;
  }

  .order .filter a:last-child {
    border-right: none;
  }

  .order .filter a.active {
    color: #fff;
    font-size: 12.495px;
  }

  .order .data {
    display: flex;
    margin-top: 12.495px;
  }

  .order .item {
    width: 50%;
  }

  .order h4 {
    font-size: 17.505px;
    color: #fff;
    margin-bottom: 6.255px;
  }

  .order span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }

  /* 销售区域 */
  .sales {
    height: 180px;
  }

  .sales .caption {
    display: flex;
    line-height: 1;
  }

  .sales h3 {
    height: 11.25px;
  }

  .sales .chart {
    flex: 1;
    padding-top: 9px;
    position: relative;
  }

  .sales .label {
    position: absolute;
    left: 26.25px;
    top: 11.25px;
    color: #4996f5;
    font-size: 8.745px;
  }

  .sales .line {
    width: 100%;
    height: 100%;
  }

  /* 渠道区块 */
  .wrap {
    display: flex;
  }

  .channel,
  .quarter {
    flex: 1;
    height: 145.005px;
  }

  .channel {
    margin-right: 12.495px;
  }

  .channel .data {
    overflow: hidden;
  }

  .channel .item {
    margin-top: 12.75px;
  }

  .channel .item:first-child {
    float: left;
  }

  .channel .item:last-child {
    float: right;
  }

  .channel h4 {
    color: #fff;
    font-size: 19.995px;
    margin-bottom: 3px;
  }

  .channel small {
    font-size: 50%;
  }

  .channel span {
    display: block;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 季度区块 */
  .quarter .inner {
    display: flex;
    flex-direction: column;
    margin: 0 -3.75px;
  }

  .quarter .chart {
    flex: 1;
    padding-top: 11.25px;
  }

  .quarter .box {
    position: relative;
  }

  .quarter .label {
    transform: translate(-50%, -30%);
    color: #fff;
    font-size: 18.75px;
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .quarter .label small {
    font-size: 50%;
  }

  .quarter .gauge {
    height: 52.5px;
  }

  .quarter .data {
    display: flex;
    justify-content: space-between;
  }

  .quarter .item {
    width: 50%;
  }

  .quarter h4 {
    color: #fff;
    font-size: 15px;
    margin-bottom: 6px;
  }

  .quarter span {
    display: block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 排行榜 */
  .top {
    height: 177px;
  }

  .top .inner {
    display: flex;
  }

  .top .all {
    display: flex;
    flex-direction: column;
    width: 105px;
    color: #4c9bfd;
    font-size: 9px;
    vertical-align: middle;
  }

  .top .all i {
    font-size: 21px;
  }

  .top .all ul {
    padding-left: 7.5px;
    margin-top: 7.5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .top .all li {
    overflow: hidden;
  }

  .top .all [class^="icon-"] {
    font-size: 22.5px;
    vertical-align: middle;
    margin-right: 7.5px;
  }

  .top .province {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #fff;
  }

  .top .province i {
    padding: 0 7.5px;
    margin-top: 3.12px;
    float: right;
    font-style: normal;
    font-size: 8.745px;
    color: #0bace6;
  }

  .top .province s {
    display: inline-block;
    transform: scale(0.8);
    text-decoration: none;
  }

  .top .province .fa-arrow-up {
    color: #dc3c33;
  }

  .top .province .fa-arrow-down {
    color: #36be90;
  }

  .top .province .data {
    flex: 1;
    display: flex;
    margin-top: 9px;
  }

  .top .province ul {
    flex: 1;
    line-height: 1;
    margin-bottom: 3.75px;
  }

  .top .province ul li {
    display: flex;
    justify-content: space-between;
  }

  .top .province ul span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .top .province ul.sup {
    font-size: 8.745px;
  }

  .top .province ul.sup li {
    color: #4995f4;
    padding: 7.5px;
  }

  .top .province ul.sup li.active {
    color: #a3c6f2;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 7.5px;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub li {
    color: #52ffff;
    padding: 6.255px 9px;
  }

  .clock {
    position: absolute;
    top: -22.5px;
    right: 25.005px;
    font-size: 12.495px;
    color: #0bace6;
  }

  .clock i {
    margin-right: 5px;
    font-size: 12.495px;
  }

  @media screen and (max-width:1600px) {
    .top span {
      transform: scale(0.9);
    }

    .top .province ul.sup li {
      padding: 6px 7.5px;
    }

    .top .province ul.sub li {
      padding: 3.45px 7.5px;
    }

    .quarter span {
      transform: scale(0.9);
    }
  }
</style>